import { useEffect } from "react";

const SITE = "https://pactora-personal.de";

function setMeta(selector, attr, value, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function useSeo(title, description, path, noindex = false, lang = "de") {
  useEffect(() => {
    document.documentElement.lang = lang;
    const full = title ? `${title} | PACTORA Personalpartner` : "PACTORA Personalpartner – Internationale Direktvermittlung";
    document.title = full;
    setMeta('meta[name="description"]', "content", description, { tag: "meta", attrs: { name: "description" } });
    setMeta('meta[property="og:title"]', "content", full, { tag: "meta", attrs: { property: "og:title" } });
    setMeta('meta[property="og:description"]', "content", description, { tag: "meta", attrs: { property: "og:description" } });
    setMeta('link[rel="canonical"]', "href", `${SITE}${path}`, { tag: "link", attrs: { rel: "canonical" } });
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow", { tag: "meta", attrs: { name: "robots" } });
  }, [title, description, path, noindex, lang]);
}
